import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "In listening experiments, it is possible to perceptually evaluate the quality of the simulation and the auralization. This can be achieved by comparing the simulation-based auralizations with measurement-based auralizations.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 3,
      rowsSize: [0.5, 5, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "Plausibility",
                  scrollbars: false,
                  styles: {
                    fontWeight: 800,
                    letterSpacing: "3.5px",
                    textTransform: "uppercase",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "iframe",
                options: {
                  src: `${config.IFRAMES_STATIC_URL}/0330/lesson_3_28_Plausibility.html`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "hint",
                options: {
                  data:
                    "The test for plausibility is less critical. Here typical content such as music for a concert hall is chosen and a simulation-based auralization can be considered as plausible, if a participant reliably considers the auralization coming from a real room.",
                  direction: "row",
                  color: "default",
                },
              },
              styles: {
                width: "590px",
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
